import { render, staticRenderFns } from "./NuevaInstitucion.vue?vue&type=template&id=1ab0dbe3"
import script from "./NuevaInstitucion.vue?vue&type=script&lang=js"
export * from "./NuevaInstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports